module.exports = __webpack_public_path__ + "static/img/kj1-5.6b2cffc.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kj1-5.png
// module id = 923
// module chunks = 0